import { render, staticRenderFns } from "./BetPeriodResultsView.vue?vue&type=template&id=31d1960c&"
import script from "./BetPeriodResultsView.vue?vue&type=script&lang=js&"
export * from "./BetPeriodResultsView.vue?vue&type=script&lang=js&"
import style0 from "./BetPeriodResultsView.vue?vue&type=style&index=0&id=31d1960c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports